import { Table, Form, Col, Row, Modal, Alert, Button, Select } from 'antd';
import axios from '../../utils/request';
import React, { Component } from 'react';
import { Spinner } from 'reactstrap';

const { Option } = Select;

const columns = [
    {
        title: '校验信息',
        dataIndex: 'verifyMsg',
        width: 800,
    },
    {
        title: '是否可发起',
        dataIndex: 'verifyPass',
        width: 200,
    },
];

export class HisenseComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            errorMessage: null,
            applicantList: null,
            productList: null,
            productId: null,
            buttonStatus: false,
            visible: false,
            submitSuccess: true,
            commonParamater: null,
            displayStatus: 'none',
            tenantId: null
        };
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        const params = {
            tenantId,
            commonParamater
        }
        axios
            .get("/api/Hisense/VerifyApplicantInfo", { params: params })
            .then(res => {
                const data = res.data.data;
                const count = data.count;
                if (count == 0) {
                    this.setState({ applicantList: data.applicants, productList: data.products, isLoading: true, buttonStatus: true });
                } else {
                    this.setState({ applicantList: data.applicants, productList: data.products, isLoading: true, buttonStatus: false});
                }
            }).catch(reason => {
                const errorMessages = reason?.response?.data?.errorMessages ?? ["获取初始信息失败。"]
                this.setState({ errorMessage: errorMessages });
                this.setState({ isLoading: true });
            })
    }

    render() {
        if (this.state.isLoading) {
            if (this.state.errorMessage != null) {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            else {
                return (
                    <div style={{ margin: "32px auto", maxWidth: "1000px" }}>
                        <Form onFinish={this.showModal}>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                    <Form.Item label="选择测评活动" name="productId"
                                        rules={[
                                            {
                                                required: true,
                                                message: "类型不能为空！"
                                            }
                                        ]}>
                                        <Select
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                            style={{ width: '50%' }}
                                            placeholder="请选择测评活动类型">
                                            {this.state.productList.map(el => (
                                                <Option value={el.proNumber}>{el.proName}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}  >
                                    <Table columns={columns} dataSource={this.state.applicantList} pagination={false} size="small" />
                                </Col>
                            </Row>
                            <div>
                                <Modal title="发送测评" visible={this.state.visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                                    <p>确定发送测评？</p>
                                </Modal>
                            </div>
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5, offset: 10 }}>
                                    <br />
                                    <Button type="primary" disabled={this.state.buttonStatus} htmlType="submit">继续</Button>
                                </Col>
                            </Row>
                        </Form>
                        <div style={{ display: this.state.displayStatus }}>
                            <Alert message="发送成功" type="success" showIcon closable={true} />
                        </div>
                    </div>)
            }
        } else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }

    onFormSubmit = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            this.setState({ isLoading: false, submitSuccess: true });
        }, 2000)
    }

    showModal = values => {
        this.setState({ productId: values.productId, visible: true });
    }

    handleOk = values => {
        const commonParamater = this.state.commonParamater;
        const tenantId = this.state.tenantId;
        const productId = this.state.productId;
        window.location.href = "/hisense_success?commonParamater=" + commonParamater + "&tenantId=" + tenantId + "&productId=" + productId;
    }

    handleCancel = (e) => {
        this.setState({ visible: false });
    }

}